import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import AddressSection from "./AddressSection";

const MENU = [
  { key: "personal", label: "Personal Data" },
  { key: "orders",   label: "Orders" },
  { key: "address",  label: "Address" },
  { key: "favorite", label: "Favorite" },
  { key: "cart",     label: "Cart" },
];

function PersonalData({ user }) {
  return (
    <div>
      <h2 style={s.sectionTitle}>Personal Data</h2>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div style={s.fieldRow}>
          <span style={s.fieldLabel}>Full Name</span>
          <span style={s.fieldValue}>{user?.fullName || user?.FullName || "—"}</span>
        </div>
        <div style={s.fieldRow}>
          <span style={s.fieldLabel}>Phone</span>
          <span style={s.fieldValue}>
            {user?.countryNumber || user?.CountryNumber}
            {user?.phoneNumber || user?.PhoneNumber || "—"}
          </span>
        </div>
      </div>
    </div>
  );
}

function OrdersSection() {
  return (
    <div>
      <h2 style={s.sectionTitle}>Orders</h2>
      <p style={s.placeholder}>Your orders will appear here.</p>
    </div>
  );
}

function FavoriteSection() {
  return (
    <div>
      <h2 style={s.sectionTitle}>Favorite</h2>
      <p style={s.placeholder}>Your favorite products will appear here.</p>
    </div>
  );
}

function CartSection() {
  return (
    <div>
      <h2 style={s.sectionTitle}>Cart</h2>
      <p style={s.placeholder}>Your cart items will appear here.</p>
    </div>
  );
}

export default function ProfilePage() {
  const { User, setUser } = useAppContext();
  const navigate = useNavigate();
  const [active, setActive] = useState("personal");

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  const user = User || JSON.parse(localStorage.getItem("user") || "{}");

  const contentMap = {
    personal: <PersonalData user={user} />,
    orders:   <OrdersSection />,
    address:  <AddressSection />,
    favorite: <FavoriteSection />,
    cart:     <CartSection />,
  };

  return (
    <>
      <div className="profile-wrapper">

        {/* Sidebar / horizontal tab nav on mobile */}
        <div className="profile-sidebar">
          {MENU.map((item) => (
            <button
              key={item.key}
              onClick={() => setActive(item.key)}
              className="profile-nav-btn"
              style={{
                background: active === item.key ? "#e11d48" : "transparent",
                color:      active === item.key ? "#fff" : "#374151",
                fontWeight: active === item.key ? 700 : 500,
              }}
            >
              {item.label}
            </button>
          ))}

          <button onClick={handleLogout} className="profile-logout-btn">
            Logout
          </button>
        </div>

        {/* Content area */}
        <div className="profile-content">
          {contentMap[active]}
        </div>
      </div>

      <style>{`
        /* ── Desktop layout ── */
        .profile-wrapper {
          display: flex;
          gap: 24px;
          padding: 28px 0 48px;
          min-height: 80vh;
          align-items: flex-start;
        }
        .profile-sidebar {
          width: 220px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          gap: 6px;
          background: #f9fafb;
          border: 1px solid #e5e7eb;
          border-radius: 16px;
          padding: 12px;
        }
        .profile-nav-btn {
          padding: 13px 16px;
          border-radius: 10px;
          border: none;
          text-align: left;
          font-size: 15px;
          cursor: pointer;
          transition: background 0.18s, color 0.18s;
          outline: none;
          width: 100%;
        }
        .profile-logout-btn {
          margin-top: 12px;
          padding: 13px 16px;
          border-radius: 10px;
          border: none;
          text-align: left;
          font-size: 15px;
          cursor: pointer;
          width: 100%;
          background: #fee2e2;
          color: #dc2626;
          font-weight: 600;
          transition: background 0.18s;
          outline: none;
        }
        .profile-content {
          flex: 1;
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 16px;
          padding: 28px;
          min-height: 400px;
        }

        /* ── Mobile layout ── */
        @media (max-width: 768px) {
          .profile-wrapper {
            flex-direction: column;
            gap: 12px;
            padding: 16px 0 40px;
            min-height: unset;
          }
          .profile-sidebar {
            width: 100%;
            flex-direction: row;
            overflow-x: auto;
            padding: 10px;
            border-radius: 14px;
            gap: 6px;
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .profile-sidebar::-webkit-scrollbar { display: none; }
          .profile-nav-btn {
            flex-shrink: 0;
            width: auto;
            padding: 9px 16px;
            font-size: 13px;
            white-space: nowrap;
            border-radius: 8px;
            text-align: center;
          }
          .profile-logout-btn {
            flex-shrink: 0;
            width: auto;
            margin-top: 0;
            padding: 9px 16px;
            font-size: 13px;
            white-space: nowrap;
            border-radius: 8px;
            text-align: center;
          }
          .profile-content {
            padding: 20px 16px;
            min-height: unset;
            border-radius: 14px;
          }
        }
      `}</style>
    </>
  );
}

/* ── Shared inner styles ── */
const s = {
  sectionTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: "#1a1a1a",
    marginTop: 0,
    marginBottom: 20,
    paddingBottom: 12,
    borderBottom: "1px solid #e5e7eb",
  },
  fieldRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px 14px",
    background: "#f9fafb",
    borderRadius: 10,
    gap: 12,
    flexWrap: "wrap",
  },
  fieldLabel: {
    fontSize: 13,
    color: "#6b7280",
    fontWeight: 500,
  },
  fieldValue: {
    fontSize: 14,
    color: "#1a1a1a",
    fontWeight: 600,
    textAlign: "right",
  },
  placeholder: {
    color: "#9ca3af",
    fontSize: 15,
    margin: 0,
  },
};
